import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=f48a9c6e&scoped=true&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a9c6e",
  null
  
)

export default component.exports